import { BaseClient } from '../client';
import { TUserUpdate } from './user.types';

export const putUser = async (body: TUserUpdate) => {
	if (process.env.NODE_ENV === 'development') {
		return 'Alterado com sucesso';
	}

	try {
		const response = await BaseClient.put<string>(`/Usuarios/${body.id}`, body).then(
			(response) => response.data
		);

		return response;
	} catch (error) {
		throw error;
	}
};
